import type { NodeViewerComponent } from '.'
import { Paragraph } from '../../components'

export const ParagraphNodeViewer: NodeViewerComponent = ({
  children,
  node,
  ...props
}) => <Paragraph {...props}>{children || <br />}</Paragraph>
